import React, { useState, useEffect, useRef } from 'react';
import { qrCodeScanningLogic } from './qrCodeScanningLogic';
import translate from "../../services/localization";

const QRCodeScanner = ({ setQRCodes, setVideoStream }) => {
  useEffect(() => {
    let timer = qrCodeScanningLogic(setQRCodes, setVideoStream);
      return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div id="loadingMessage">
          {translate('login').noCamAvailable}
      </div>
      <canvas id="canvas" hidden></canvas>
      <div id="output" style={{display: 'none'}}>
        <div id="outputMessage">{translate('login').noQRCodeRecognized}</div>
        <div hidden>
          <b>Data:</b> <span id="outputData"></span>
        </div>
      </div>
    </>
  );
};

export default QRCodeScanner;
